import { createFileRoute, Link } from '@tanstack/react-router'
import { Section } from '@/components/ui/section'
import { Button } from '@/components/ui/button'
import { Code2, Terminal, Cpu, Share2 } from 'lucide-react'

export const Route = createFileRoute('/developers')({
  component: DevelopersComponent,
})

function DevelopersComponent() {
  return (
    <div className="min-h-screen">
      <section className="gradient-hero py-20">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 badge badge-primary mb-6">
              <Terminal className="h-4 w-4" />
              <span>Developer Portal</span>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Build & Monetize <span className="text-gradient">Trading Algorithms</span>
            </h1>
            <p className="text-xl text-muted-foreground mb-8">
              Use our SDK to build high-frequency trading bots, backtest continuously, and list them on our global marketplace.
            </p>
            <div className="flex gap-4 justify-center">
              <Link to="/developer/submit">
                <Button size="lg">Submit Algorithm</Button>
              </Link>
              <Button variant="outline" size="lg">Read Documentation</Button>
            </div>
          </div>
        </div>
      </section>

      <Section>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="card p-6">
            <Code2 className="h-10 w-10 text-primary mb-4" />
            <h3 className="text-xl font-semibold mb-2">Powerful SDK</h3>
            <p className="text-muted-foreground">Python and TypeScript SDKs for building strategies with ease.</p>
          </div>
          <div className="card p-6">
            <Cpu className="h-10 w-10 text-primary mb-4" />
            <h3 className="text-xl font-semibold mb-2">Cloud Execution</h3>
            <p className="text-muted-foreground">Deploy your bots to our low-latency infrastructure closer to the exchange.</p>
          </div>
          <div className="card p-6">
            <Share2 className="h-10 w-10 text-primary mb-4" />
            <h3 className="text-xl font-semibold mb-2">Revenue Share</h3>
            <p className="text-muted-foreground">Keep 80% of subscription revenue generated by your algorithms.</p>
          </div>
        </div>
      </Section>
    </div>
  )
}
